import { Card, Stack, Text } from '@mantine/core';

import { useNavigate, useParams } from 'react-router-dom';

import { useCallback } from 'react';

import { type Proposal } from '../../../types/apiTypes';
import { ProposalStatusItem } from '../../../components/DropdownMenus';
import { ProposalStatusType } from '../../../utils/constants';
import classes from './RecentProposalCard.module.css';
import { getProposalRouteFromStatus } from '../../../utils/routerUtils';

interface Props {
  proposal: Proposal
}

const UNCLICKABLE_STATUSES = [ProposalStatusType.GENERATING, ProposalStatusType.PROCESSING];
const RecentProposalCard: React.FC<Props> = (props: Props) => {
  const { proposal } = props;
  const { organization } = useParams();
  const navigate = useNavigate();
  const proposalStatus = proposal.status as ProposalStatusType;
  const canClick = !UNCLICKABLE_STATUSES.includes(proposalStatus);
  const handleOnClick = useCallback(() => {
    const route = getProposalRouteFromStatus(
      organization ?? '',
      proposal.uid,
      proposalStatus
    );
    navigate(route);
  }, [organization, status, proposal.uid]);

  return (
    <Card
      h={89}
      radius={4}
      shadow='2px 2px 4px 0px #0000001A'
      className={classes.card}
      onClick={canClick ? handleOnClick : undefined}
    >
      <Stack gap={0}>
        <Text w='100%' truncate>
          {proposal.name}
        </Text>
        <ProposalStatusItem status={proposalStatus} />
      </Stack>
    </Card >);
};

export default RecentProposalCard;
